import classnames from "classnames";
import { SelectControl } from "@wordpress/components";
import {THEME_VARIABLES, THEME_VARIABLES_MAP} from "~buildable/utils/constants";

const ThemeColorSelect = props => {
  const options = THEME_VARIABLES;
  const map = THEME_VARIABLES_MAP;

  if (!options || !map) {
    return null;
  }

  const {
    className,
    label,
    value,
    onChange,
    addPlaceholderOption
  } = props;

  if (
    addPlaceholderOption &&
    typeof options.find(option => option.value === "") === "undefined"
  ) {
    options.unshift({ label: "Select a color", value: "" });
  }

  let selectedColorStyle = {};
  if (value) {
    selectedColorStyle.backgroundColor = map[value];

    if (value !== "light") {
      selectedColorStyle.borderColor = map[value];
    } else {
      selectedColorStyle.borderColor = "gray";
    }
  }

  const classes = classnames(["theme-color-select", className]);
  const colorCircleClasses = classnames(["color-circle"], { "no-color": !value });

  return (
    <div className={ classes }>
      <SelectControl
        label={ label }
        value={ value }
        options={ options }
        onChange={ onChange }
      />
      <div
        className={ colorCircleClasses }
        style={ selectedColorStyle }
      />
    </div>
  )
}

export default ThemeColorSelect;
